__webpack_require__.p = "/sidebar-menu-marketplace-fix/system-email-templates/";